{
  "title": "API и интеграции",
  "intro": "Ключи дают скриптам, CI и ИИ-агентам управлять инфраструктурой через наш API. Ключ может только то, что разрешает его политика, только в своих проектах и никогда больше, чем его владелец.",
  "tabs": {
    "keys": "Ключи",
    "service-accounts": "Сервисные аккаунты",
    "policies": "Политики",
    "endpoints": "Эндпоинты",
    "activity": "Активность",
    "approvals": "Одобрения",
    "apps": "Подключённые приложения"
  },
  "intros": {
    "policies": "Политика говорит, что может ключ: какие действия, в каких проектах и какие из них ждут одобрения человека.",
    "approvals": "Запросы ключей и ИИ-агентов, которые ждут решения человека, и что стало с прежними.",
    "apps": "ИИ-клиенты, которые вы подключили к панели входом (claude.ai, ChatGPT и другие): что каждому можно и как его отключить."
  },
  "messengers": {
    "title": "Мессенджеры",
    "intro": "Через мессенджеры панель присылает оповещения и запросы на одобрение. Подключает их администратор организации, а каждый потом привязывает свой аккаунт в «Настройки уведомлений».",
    "kindsLabel": "Мессенджеры",
    "notSet": "Не настроен",
    "adminsOnly": "Мессенджеры подключают администраторы организации. Свой Telegram для оповещений вы привязываете в «Настройки уведомлений».",
    "telegram": {
      "name": "Telegram",
      "about": "Боты организации: оповещения, запросы на одобрение, групповые чаты проектов.",
      "bots": "Ботов: {{n}}"
    }
  },
  "status": {
    "active": "Действует",
    "expired": "Истёк",
    "revoked": "Отозван"
  },
  "policy": {
    "custom": "Свои правила",
    "customLead": "Отметьте в матрице ресурсов и действий, что ключу можно.",
    "library": "Политика вашей организации"
  },
  "projects": {
    "all": "Все проекты"
  },
  "yes": "Да",
  "no": "Нет",
  "copy": "Копировать",
  "copyThing": "Копировать: {{thing}}",
  "copied": "Скопировано.",
  "copyFailed": "Не удалось скопировать. Выделите текст и скопируйте сами.",
  "snippets": {
    "env": "Переменная окружения",
    "curl": "Проверить через curl",
    "curlHint": "Покажет проекты, к которым у ключа есть доступ."
  },
  "keys": {
    "create": "Создать ключ",
    "empty": "API-ключей пока нет",
    "emptyLead": "Создайте ключ для скрипта, CI или ИИ-агента. Вы выбираете, что ему можно и где; больше прав, чем у вас, он не получит.",
    "name": "Ключ",
    "owner": "Владелец",
    "serviceAccount": "Сервисный аккаунт",
    "policy": "Политика",
    "projects": "Проекты",
    "expires": "Действует до",
    "never": "Бессрочно",
    "lastUsed": "Использован",
    "notUsed": "Ещё не использовался",
    "status": "Состояние",
    "open": "Открыть"
  },
  "revoke": {
    "title": "Отозвать ключ «{{name}}»?",
    "stops": "Все программы с этим ключом сразу потеряют доступ.",
    "final": "Отменить нельзя; если ключ снова понадобится, создайте новый.",
    "action": "Отозвать",
    "done": "Ключ «{{name}}» отозван."
  },
  "templates": {
    "read_only": {
      "name": "Только чтение",
      "lead": "Видит всё в своих проектах, ничего не меняет."
    },
    "monitoring": {
      "name": "Мониторинг",
      "lead": "Списки, подробности, метрики и операции: хватит для дашбордов и оповещений."
    },
    "operator": {
      "name": "Оператор",
      "lead": "Смотрит, включает и выключает серверы, перезагружает; консоль — только если разрешены секретные действия."
    },
    "developer": {
      "name": "Разработчик",
      "lead": "Всё, кроме удаления, переустановки и удаления резервных копий."
    },
    "full_access": {
      "name": "Полный доступ",
      "lead": "Всё, что может владелец; удаление ждёт одобрения человека во вкладке «Одобрения»."
    },
    "ci_deploy": {
      "name": "Деплой из CI",
      "lead": "Смотрит, создаёт и удаляет серверы, включает их, применяет файрволы, подключает сети."
    }
  },
  "groups": {
    "projects": "Проекты",
    "members": "Доступ к проекту",
    "catalogue": "Каталог",
    "operations": "Операции",
    "activities": "Лента событий",
    "dashboard": "Дашборд",
    "servers": "Серверы",
    "images": "Снимки и резервные копии",
    "ssh_keys": "SSH-ключи",
    "networks": "Сети",
    "firewalls": "Файрволы",
    "public_ips": "Публичные IP",
    "floating_ips": "Плавающие IP",
    "volumes": "Диски",
    "placement_groups": "Группы размещения",
    "api_keys": "API-ключи",
    "api_policies": "Политики",
    "api_settings": "Настройки API",
    "service_accounts": "Сервисные аккаунты",
    "users": "Пользователи",
    "invitations": "Приглашения",
    "auth": "Вход",
    "me": "Ваша учётная запись",
    "events": "Живые обновления",
    "meta": "Сервис",
    "service": "Сервис",
    "stand": "Тестовый стенд",
    "account": "Ваша учётная запись",
    "connections": "Подключение к провайдеру",
    "load_balancers": "Балансировщики",
    "certificates": "Сертификаты",
    "costs": "Расходы",
    "budgets": "Бюджеты",
    "notifications": "Уведомления",
    "alerts": "Оповещения",
    "autopilot": "Мониторинг (Автопилот)",
    "packages": "Пакеты",
    "assistant": "ИИ-ассистент",
    "mcp": "MCP-сервер",
    "approvals": "Подтверждения",
    "oauth": "OAuth",
    "connected_apps": "Подключённые приложения"
  },
  "risk": {
    "read": "Чтение",
    "operate": "Управление",
    "change": "Изменение",
    "create": "Создание",
    "destroy": "Удаление",
    "secret": "Секреты",
    "admin": "Администрирование"
  },
  "matrix": {
    "label": "Что можно ключу: по ресурсам и видам действий",
    "group": "Ресурс",
    "column": "Все ресурсы: {{risk}}",
    "cell": "{{group}}: {{risk}}",
    "states": {
      "all": "Разрешено",
      "some": "Разрешено частично",
      "approval": "Нужно подтверждение",
      "none": "Запрещено",
      "absent": "Таких действий нет"
    },
    "view": "Вид",
    "views": {
      "matrix": "Матрица",
      "yaml": "YAML"
    },
    "extraAllow": "Разрешить также",
    "extraAllowHint": "Отдельные действия или шаблоны, по одному в строке: servers.reboot, volumes.*, risk:read.",
    "deny": "Всегда запрещать",
    "denyHint": "Сильнее всего остального, например servers.delete или risk:destroy."
  },
  "wizard": {
    "title": "Новый API-ключ",
    "intro": "Пять коротких шагов. В конце ключ покажется один раз; сохраните его в менеджере паролей или секретах CI.",
    "steps": "Шаги",
    "step": {
      "who": "Чей",
      "policy": "Что можно",
      "projects": "Где",
      "limits": "Ограничения",
      "review": "Проверить и создать"
    },
    "name": "Название",
    "nameHint": "Напишите, кто им пользуется, например «Деплой из GitHub Actions».",
    "description": "Описание",
    "owner": "Принадлежит",
    "ownerMe": "Мне",
    "ownerMeLead": "Ключ никогда не получит больше прав, чем у вас, и перестанет работать, если вы покинете организацию.",
    "ownerAccount": "Сервисный аккаунт ({{role}}): свои права, не зависят от человека",
    "policy": "Политика",
    "allowSecret": "Разрешить секретные действия",
    "allowSecretLead": "Пароли root, консоль, SSH-ключи. Не включайте, если ключу это точно не нужно.",
    "allowSecretOff": "Ваша организация не даёт ключам секретные действия (вкладка «Эндпоинты»).",
    "projects": "Проекты",
    "allProjectsLead": "Все проекты, доступные владельцу, включая будущие.",
    "someProjects": "Выбранные проекты",
    "someProjectsLead": "Только отмеченные ниже.",
    "lifetime": "Срок действия",
    "days": "Дней: {{count}}",
    "ipAllowList": "Разрешённые адреса",
    "ipAllowListHint": "IP-адреса или диапазоны, по одному в строке (203.0.113.7, 10.0.0.0/8). Пусто — откуда угодно.",
    "rateLimit": "Запросов в минуту",
    "rateLimitHint": "Пусто — по умолчанию для организации ({{count}} в минуту).",
    "anywhere": "Откуда угодно",
    "rateDefault": "По умолчанию для организации ({{count}} в минуту)",
    "perMinute": "{{count}} в минуту",
    "back": "Назад",
    "next": "Далее",
    "create": "Создать ключ",
    "createdTitle": "Ключ «{{name}}» создан",
    "shownOnce": "Скопируйте ключ сейчас: он показывается только один раз. Мы храним лишь его отпечаток.",
    "token": "API-ключ",
    "toKey": "Открыть ключ",
    "done": "Готово"
  },
  "rotate": {
    "title": "Перевыпустить ключ",
    "lead": "Новый секрет заменит старый. Старый ещё поработает выбранное время, чтобы вы успели обновить программы.",
    "grace": "Старый секрет работает ещё",
    "graces": {
      "0": "Нисколько (перестанет сразу)",
      "1": "1 час",
      "24": "24 часа",
      "72": "3 дня",
      "168": "7 дней"
    },
    "action": "Перевыпустить",
    "doneTitle": "Новый секрет"
  },
  "key": {
    "saved": "Ключ сохранён.",
    "rateHint": "Пусто — по умолчанию для организации.",
    "previousValid": "Секрет до последнего перевыпуска работает до {{when}}.",
    "createdBy": "Создал",
    "lastUsedFrom": "{{when}} с {{ip}} ({{client}})",
    "requests": "Запросов",
    "revokedAt": "Отозван",
    "whatItMayDo": "Что можно",
    "whatItMayDoLead": "В его проектах и никогда больше, чем может владелец. Секретные действия — только если разрешены выше.",
    "settings": "Название и ограничения"
  },
  "activity": {
    "actions": {
      "api_key_created": "Ключ создан",
      "api_key_updated": "Ключ изменён",
      "api_key_rotated": "Ключ перевыпущен",
      "api_key_revoked": "Ключ отозван",
      "api_key_refused": "Ключ отклонён",
      "access_denied": "Вызов отклонён",
      "mcp_tool_call": "Вызов инструмента MCP",
      "approval_requested": "Запрошено одобрение",
      "approval_approved": "Одобрено",
      "approval_rejected": "Отклонено",
      "approval_executed": "Выполнено по одобрению",
      "approval_failed": "Не выполнено по одобрению",
      "approval_expired": "Срок одобрения истёк"
    },
    "empty": "Пока ничего",
    "emptyLead": "Здесь появятся изменения, сделанные ключами, отказы и изменения самих ключей.",
    "at": "Когда",
    "key": "Ключ",
    "action": "Что",
    "byPerson": "сделал(а) {{name}}",
    "outcome": "Итог",
    "outcomes": {
      "success": "Сделано",
      "denied": "Отклонено",
      "failed": "Ошибка"
    },
    "ip": "Адрес",
    "filterKey": "Ключ",
    "allKeys": "Все ключи",
    "filterAccount": "Сервисный аккаунт",
    "allAccounts": "Все сервисные аккаунты",
    "tool": "Инструмент: {{name}}"
  },
  "accounts": {
    "intro": "Сервисные аккаунты — участники-программы, а не люди: CI, ИИ-агент. У них есть роль и доступ к проектам, как у человека, а их ключи переживают того, кто их создал.",
    "create": "Добавить сервисный аккаунт",
    "createTitle": "Новый сервисный аккаунт",
    "editTitle": "Сервисный аккаунт",
    "lead": "За него отвечает человек; без активного ответственного ключи аккаунта перестают работать.",
    "name": "Название",
    "description": "Описание",
    "owner": "Ответственный",
    "ownerHint": "Человек, который следит за этим аккаунтом.",
    "role": "Роль",
    "noOwner": "Нет ответственного",
    "keys": "Ключи",
    "disabled": "Отключён",
    "enabled": "Действует",
    "edit": "Изменить",
    "enable": "Включить",
    "disable": "Отключить",
    "enabledDone": "«{{name}}» снова действует.",
    "disabledDone": "«{{name}}» отключён; его ключи отклоняются.",
    "remove": "Удалить",
    "removeTitle": "Удалить «{{name}}»?",
    "removeKeys": "Его ключи ({{count}}) удалятся вместе с ним и сразу перестанут работать.",
    "removed": "«{{name}}» удалён.",
    "empty": "Сервисных аккаунтов нет",
    "emptyLead": "Добавьте аккаунт для CI или агента, чьи ключи не должны зависеть от человека."
  },
  "policies": {
    "library": "Ваши политики",
    "libraryLead": "Правила для ключей, которыми можно пользоваться повторно. Изменение политики сразу меняет все ключи с ней.",
    "create": "Новая политика",
    "newTitle": "Новая политика",
    "editorIntro": "Отметьте, что можно ключам с этой политикой в их проектах. Больше, чем может их владелец, они не получат.",
    "empty": "Своих политик нет",
    "emptyLead": "Шаблонов ниже хватает почти всегда; своя политика нужна, когда нескольким ключам нужны одни и те же особые правила.",
    "name": "Название",
    "description": "Описание",
    "usedBy": "Ключи",
    "usedByCount": "Ключей с ней: {{count}}",
    "updated": "Изменена",
    "edit": "Изменить",
    "remove": "Удалить",
    "removeTitle": "Удалить политику «{{name}}»?",
    "removeLead": "Удалить можно только политику, которую не использует ни один ключ.",
    "removed": "Политика «{{name}}» удалена.",
    "templates": "Шаблоны",
    "templatesLead": "Встроенные; выберите при создании ключа или начните с них свою политику.",
    "rules": "Правила",
    "rulesLead": "Строки — ресурсы, столбцы — виды действий.",
    "startFrom": "Начать с шаблона",
    "untitled": "Новая политика",
    "notMatrix": "В этой политике есть правила, которые матрица не покажет точно (подтверждения, списки проектов). Чтобы править её здесь, пересоберите её матрицей.",
    "rebuild": "Пересобрать матрицей"
  },
  "endpoints": {
    "rest": "REST API",
    "restLead": "Тот же API, что у панели. Передавайте ключ в заголовке Authorization: Bearer; изменения требуют заголовок Idempotency-Key.",
    "baseUrl": "Базовый адрес",
    "openapi": "Описание OpenAPI",
    "mcp": "MCP-сервер для ИИ-агентов",
    "mcpLead": "Сюда подключаются ИИ-агенты (Claude Code, Claude Desktop, Cursor, VS Code, Codex и другие) с API-ключом. Они видят только инструменты, которые разрешает политика ключа.",
    "settings": "Переключатели и значения по умолчанию",
    "settingsLead": "Для всей организации.",
    "apiEnabled": "API включён",
    "apiEnabledLead": "Выключен — все ключи сразу отклоняются; панель продолжает работать.",
    "allowSecret": "Ключам можно давать секретные действия",
    "allowSecretLead": "Пароли root, консоль, SSH-ключи. Каждому ключу это всё равно нужно включить отдельно.",
    "defaultRate": "Запросов в минуту по умолчанию",
    "defaultRateHint": "Для ключей без своего ограничения.",
    "maxLifetime": "Наибольший срок ключа, дней",
    "maxLifetimeHint": "Пусто — без ограничения (тогда администраторы могут создавать бессрочные ключи).",
    "adminsOnly": "Менять это могут только администраторы.",
    "saved": "Настройки сохранены.",
    "mcpUrl": "Адрес MCP-сервера",
    "mcpOff": "MCP выключен: MCP-сервер отклоняет ИИ-агентов. У REST API свой переключатель.",
    "mcpEnabled": "MCP-сервер включён",
    "mcpEnabledLead": "Выключен — все ИИ-агенты сразу отклоняются; REST API продолжает работать."
  },
  "docs": {
    "open": "Документация API",
    "title": "Документация API",
    "intro": "Все операции API с их разрешением и видом действия. Ключ может вызвать операцию, если её разрешение дают его политика и его владелец.",
    "example": "Примеры",
    "exampleHint": "Замените <project id> на id из первого ответа.",
    "search": "Поиск по пути или разрешению",
    "nothing": "Ничего не нашлось.",
    "parameters": "Параметры",
    "name": "Имя",
    "in": "Где",
    "type": "Тип",
    "body": "Тело запроса (JSON-схема)",
    "responses": "Ответы: {{codes}}"
  },
  "mcp": {
    "title": "Подключить ИИ-агента (MCP)",
    "client": "MCP-клиент",
    "snippet": "Подключение: {{client}}",
    "placeholder": "Замените csk_… на ключ.",
    "safety": "Агент видит только инструменты, которые разрешает политика ключа. Для удаления нужно точное имя ресурса, а пароли ему никогда не показываются.",
    "oauthLater": "claude.ai, коннекторы приложений Claude и ChatGPT входят через браузер (OAuth) — это появится на следующем шаге. Пока Claude Desktop подключается через mcp-remote, как показано.",
    "clients": {
      "claude-code": {
        "name": "Claude Code",
        "where": "Выполните в терминале, где задана переменная CLOUDSERVER_API_KEY."
      },
      "claude-desktop": {
        "name": "Claude Desktop",
        "where": "Добавьте в claude_desktop_config.json (Settings → Developer → Edit config) и перезапустите Claude Desktop. Нужен Node.js."
      },
      "cursor": {
        "name": "Cursor",
        "where": "Добавьте в ~/.cursor/mcp.json (или .cursor/mcp.json проекта). Cursor берёт CLOUDSERVER_API_KEY из окружения."
      },
      "vscode": {
        "name": "VS Code (Copilot)",
        "where": "Сохраните как .vscode/mcp.json. VS Code один раз спросит ключ и сохранит его в своём хранилище секретов."
      },
      "codex": {
        "name": "Codex CLI",
        "where": "Добавьте в ~/.codex/config.toml. Codex берёт CLOUDSERVER_API_KEY из окружения."
      },
      "windsurf": {
        "name": "Windsurf",
        "where": "Добавьте в ~/.codeium/windsurf/mcp_config.json."
      },
      "gemini": {
        "name": "Gemini CLI",
        "where": "Добавьте в ~/.gemini/settings.json. Gemini CLI берёт CLOUDSERVER_API_KEY из окружения."
      },
      "other": {
        "name": "Другой клиент",
        "where": "Любой MCP-клиент, который умеет Streamable HTTP и свои заголовки."
      }
    }
  },
  "approvals": {
    "lead": "Вызовы ключей, подключённых приложений и ИИ-агентов, которые по их политике ждут решения человека. Одобрить может тот, кто сам вправе это сделать: администратор или владелец проекта.",
    "open": "Ждут решения",
    "closed": "История",
    "empty": "Нет запросов",
    "emptyLead": "Когда ключ с политикой «Полный доступ» или своими правилами попросит, например, удалить ресурс, запрос появится здесь, а вам придёт уведомление.",
    "emptyClosed": "Решённых запросов пока нет.",
    "waitingForMe": "Ждут вашего решения: {{count}}",
    "action": "Действие",
    "target": "Над чем",
    "project": "Проект",
    "requester": "Кто просит",
    "when": "Когда",
    "expires": "Истекает",
    "expiresIn": "истекает {{when}}",
    "status": "Статус",
    "openItem": "Открыть",
    "statuses": {
      "pending": "Ждёт решения",
      "approved": "Выполняется",
      "executed": "Выполнено",
      "failed": "Не выполнено",
      "rejected": "Отклонено",
      "expired": "Истекло"
    },
    "back": "Все запросы",
    "title": "Запрос на одобрение",
    "intro": "Ключ просит выполнить действие, которое его политика отдаёт на решение человеку. После одобрения выполнится ровно этот запрос, один раз, от имени ключа.",
    "what": "Что будет сделано",
    "who": "Кто просит",
    "why": "Почему нужно одобрение",
    "request": "Запрос",
    "method": "Метод и путь",
    "body": "Параметры",
    "noBody": "Без параметров",
    "fingerprint": "Отпечаток запроса",
    "fingerprintHint": "Одобряя, вы подтверждаете именно этот отпечаток: если запрос изменят, он не выполнится.",
    "key": "Ключ",
    "owner": "Владелец ключа",
    "serviceAccount": "сервисный аккаунт",
    "answersFor": "Отвечает за ключ",
    "client": "Программа",
    "ip": "Адрес",
    "via": "Канал",
    "viaRest": "REST API",
    "viaMcp": "MCP, инструмент {{tool}}",
    "policy": "Политика",
    "risk": "Класс риска",
    "createdAt": "Запрошено",
    "expiresAt": "Действует до",
    "cost": "Стоимость",
    "costMonthly": "{{amount}} в месяц",
    "costToMonthEnd": "до конца месяца: {{amount}}",
    "costForecast": "{{from}} → {{to}}",
    "costNone": "Это действие не добавляет расходов.",
    "costUnknown": "Стоимость сейчас не посчитать (ресурса или цены нет в каталоге).",
    "budgetRuleNew": "Правило бюджета: новая платная услуга",
    "budgetRuleChange": "Правило бюджета: изменение существующей услуги",
    "budgetBlocked": "Бюджет проекта не позволит это владельцу ключа: при выполнении запрос будет отклонён.",
    "budgetOk": "В пределах бюджета проекта.",
    "budgetCheckedAgain": "Бюджет проверяется ещё раз в момент выполнения.",
    "decision": "Решение",
    "decidedBy": "Решил(а): {{name}}, {{when}}",
    "note": "Комментарий",
    "result": "Результат",
    "resultStatus": "Ответ HTTP {{status}}",
    "approve": "Одобрить и выполнить",
    "approveNote": "Комментарий (необязательно)",
    "approveLead": "Запрос выполнится сразу, один раз, от имени ключа «{{key}}». Понадобится второй фактор.",
    "reject": "Отклонить",
    "rejectTitle": "Отклонить запрос",
    "rejectReason": "Причина",
    "rejectReasonHint": "Её увидят владелец ключа и программа, которая просила.",
    "approved": "Одобрено и выполнено",
    "approvedFailed": "Одобрено, но не выполнено",
    "rejected": "Запрос отклонён",
    "cannotDecide": "Решить этот запрос может администратор или владелец проекта.",
    "destroyWarning": "Это действие удаляет данные или ресурсы, отменить его нельзя.",
    "forecast": "Прогноз месяца",
    "app": "Подключённое приложение"
  }
}
